import Repository from '../../Repository';
import { useToast } from 'vue-toastification';

const resource = '/company';
const toast = useToast();

export default {
	show(id) {
		return Repository.get(`/company/${id}`);
	}
}